var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useAnimation)?_c('vue-animation-wrapper',{attrs:{"animation-name":"vue-animation-fade","appear":_vm.animationAfterMount}},[_c(_vm.typeWithPrefix,{key:_vm.typeWithPrefix,tag:"component"})],1):_c(_vm.typeWithPrefix,{key:_vm.typeWithPrefix,tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }